/**
 * FORCE RESTORE CONSOLE FOR DEVELOPMENT
 * This runs FIRST to restore console functionality before anything else
 */

// Suppress generic "Script error" from cross-origin scripts FIRST
window.addEventListener('error', (event) => {
  // Suppress generic "Script error" which is a cross-origin error (Monaco editor, etc.)
  if (event.message === 'Script error.' || event.message === 'Script error') {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}, true);

// Suppress unhandled promise rejections that are just noise
window.addEventListener('unhandledrejection', (event) => {
  // Suppress network errors and other common noise
  if (event.reason?.message?.includes('Network Error') || 
      event.reason?.message?.includes('Failed to fetch') ||
      event.reason?.message?.includes('Load failed')) {
    event.preventDefault();
    return;
  }
});

// Get the REAL native console before it gets overridden
const iframe = document.createElement('iframe');
iframe.style.display = 'none';
document.head.appendChild(iframe);
const nativeConsole = iframe.contentWindow.console;
document.head.removeChild(iframe);

// Create working console with native methods
const workingConsole = {
  log: nativeConsole.log.bind(nativeConsole),
  error: nativeConsole.error.bind(nativeConsole),
  warn: nativeConsole.warn.bind(nativeConsole),
  info: nativeConsole.info.bind(nativeConsole),
  debug: nativeConsole.debug.bind(nativeConsole),
  trace: nativeConsole.trace.bind(nativeConsole),
  table: nativeConsole.table.bind(nativeConsole),
  dir: nativeConsole.dir.bind(nativeConsole),
  group: nativeConsole.group.bind(nativeConsole),
  groupEnd: nativeConsole.groupEnd.bind(nativeConsole),
  groupCollapsed: nativeConsole.groupCollapsed.bind(nativeConsole),
  time: nativeConsole.time.bind(nativeConsole),
  timeEnd: nativeConsole.timeEnd.bind(nativeConsole),
  count: nativeConsole.count.bind(nativeConsole),
  assert: nativeConsole.assert.bind(nativeConsole),
  clear: nativeConsole.clear.bind(nativeConsole)
};

// FORCE restore console immediately
Object.defineProperty(window, 'console', {
  value: workingConsole,
  writable: true,
  configurable: true
});

// Verify it works
console.log('✅ Console FULLY RESTORED for development!');
console.log('🔧 All console methods are now working');

// FORCE test all console methods
console.log('TEST LOG');
console.error('TEST ERROR');
console.warn('TEST WARN');
console.info('TEST INFO');

// Store original console globally for debugging
window._nativeConsole = workingConsole;

export default workingConsole;
